/** =========================================================
 * Orders controller
 =========================================================*/

(function () {
  'use strict';

  angular
    .module('app.page-orders')
    .controller('OrdersController', OrdersController);

  OrdersController.$inject = [
    '$rootScope',
    '$scope',
    '$api',
    '$state',
    '$stateParams',
    '$translate',
    '$controller',
    '$q',
    '$window',
    '$location',
    'ngDialog',
    'MainPreloader'
  ];

  function OrdersController(
    $rootScope,
    $scope,
    $api,
    $state,
    $stateParams,
    $translate,
    $controller,
    $q,
    $window,
    $location,
    ngDialog,
    MainPreloader
  ) {
    var vm = this;
    var orderDialogScope;

    vm.pageTitle = $state.current.title;
    vm.pageSubTitle = $state.current.subTitle;
    vm.init = false;

    if ($rootScope.appConfig) {
      activate();
    } else {
      var getAppConfig = $rootScope.$watch('appConfig', function (value) {
        if (value) {
          activate();
          getAppConfig();
        }
      });
    }

    // //////////////

    function activate() {
      vm.init = true;

      Raven.captureBreadcrumb({
        message: 'Page orders',
        data: {
          filters: $stateParams.filters
        }
      });

      var filters = function () {
        if (typeof $location.search().id !== 'undefined') {
          return [{
            'attr': 'where',
            'name': '',
            'value': [['id', '=', $location.search().id]]
          }];
        }

        return angular.copy($stateParams.filters);
      };

      function updateData() {
        try {
          return vm.tableConfig.getData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      }

      function addOrderTask(item) {
        try {
          item.order_tasks.push({
            order_task_type_id: null,
            deadline: item.deadline
          });

          if (item.order_tasks.length > 1) {
            vm.tableConfig.lists.order_tasks_links[item.order_tasks.length - 1] = false;
          }
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function removeOrderTask(item, index) {
        try {
          item.order_tasks.splice(index, 1);

          if (item.order_tasks.length > 0) {
            delete vm.tableConfig.lists.order_tasks_links[item.order_tasks.length];
          }
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function setCustomer(item, customers) {
        try {
          var definedCustomer = customers.filter(function (customer) {
            return customer.id === item.customer_id;
          })[0];

          item.emails = definedCustomer.emails;
          vm.tableConfig.variables.customer = definedCustomer;
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function toggleEmail(item, email) {
        try {
          if (item.emails.filter(function (itemEmail) {
            return itemEmail === email;
          }).length === 0) {
            item.emails.push(email);
          } else {
            item.emails = item.emails.filter(function (itemEmail) {
              return itemEmail !== email;
            });
          }
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function toggleEmails(item, emails) {
        try {
          if (item.emails.length !== emails.length) {
            item.emails = emails;
            item.include_user_email = true;
          } else {
            item.emails = [];
            item.include_user_email = false;
          }
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function isEmailPresent(item, email) {
        try {
          return item.emails.filter(function (itemEmail) {
            return itemEmail === email;
          }).length !== 0;
        } catch (error) {
          Raven.captureException(error);
        }

        return false;
      }

      function addFile(item) {
        try {
          var orderFile = {
            type: 'wetransfer',
            name: null,
            url: null
          };

          item.order_files.push(orderFile);
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function removeFile(item, index) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            if (item.order_files[index].id) {
              item.order_files[index].delete = true;
            } else {
              item.order_files.splice(index, 1);
            }
          });
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function removeFiles(item) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            var orderFiles = [];

            item.order_files.forEach(function (orderFile) {
              if (orderFile.id) {
                orderFile.delete = true;
                orderFiles.push(orderFile);
              }
            });

            item.order_files = orderFiles;
          });
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function removeSelectedFiles(item, orderFilesToDelete) {
        try {
          var dialogScope = $scope.$new(true);

          dialogScope.message = 'Do you really want to delete?';

          ngDialog.openConfirm({
            template: 'app/views/dialogs/confirm.html',
            scope: dialogScope
          }).then(function () {
            var orderFiles = [];

            item.order_files.forEach(function (orderFile, index) {
              if (orderFilesToDelete[index] === true) {
                if (orderFile.id) {
                  orderFile.delete = true;
                  orderFiles.push(orderFile);
                }
              } else {
                orderFiles.push(orderFile);
              }
            });

            item.order_files = orderFiles;
          });
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function addAllFiles(item, orderFilesToDelete, checkboxValue) {
        try {
          var flop = checkboxValue === true ? false : true;

          item.order_files.forEach(function (orderFile, index) {
            orderFilesToDelete[index] = flop;
          });
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function dropFiles(event, item) {
        try {
          event.preventDefault();

          var uploads = [];
          var sizeLimit = 5;

          MainPreloader.show();

          for (var i = 0; i < event.dataTransfer.files.length; i++) {
            var file = event.dataTransfer.files[i];

            if (file.size <= sizeLimit * 1024 * 1024) {
              uploads.push(
                $api.uploadFile({
                  file: file,
                  preventImage: true,
                  originalName: true
                }).then(function (response) {
                  item.order_files.push({
                    type: 'ordinary',
                    name: null,
                    url: response.data
                  });
                })
              );
            } else {
              alert('Too big! limit: ' + sizeLimit + 'mb');
            }
          }

          $q.all(uploads).then(function () {
            $(event.target).css('border-color', '#ccc');

            MainPreloader.hide();
          });
        } catch (error) {
          MainPreloader.hide();

          Raven.captureException(error);
        }
      }

      function pasteFile(item) {
        return function (event) {
          var clipboardItems = (event.clipboardData || event.originalEvent.clipboardData).items;
          var uploads = [];
          var sizeLimit = 5;

          MainPreloader.show();

          for (var i = 0; i < clipboardItems.length; i++) {
            var clipboardItem = clipboardItems[i];

            if (clipboardItem.kind === 'file') {
              var file = clipboardItem.getAsFile();

              if (file.size <= sizeLimit * 1024 * 1024) {
                uploads.push(
                  $api.uploadFile({
                    file: file,
                    preventImage: true,
                    originalName: true
                  }).then(function (response) {
                    item.order_files.push({
                      type: 'ordinary',
                      name: null,
                      url: response.data
                    });
                  })
                );
              }
            }
          }

          $q.all(uploads).then(MainPreloader.hide, MainPreloader.hide);
        };
      }

      function allowDropFiles(event) {
        try {
          event.stopPropagation();
          event.preventDefault();
          $(event.target).css('border-color', 'red');
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function leaveDropFiles(event) {
        try {
          $(event.target).css('border-color', '#ccc');
        } catch (error) {
          Raven.captureException(error);
        }
      }

      function processFiles(orderId, orderFiles) {
        var actions = [];

        orderFiles.forEach(function (orderFile) {
          orderFile.order_id = orderId;

          if (orderFile.delete) {
            actions.push($api.delete({
              model: 'order_file',
              data: orderFile
            }));
          } else if (!orderFile.id) {
            actions.push($api.add({
              model: 'order_file',
              data: orderFile
            }));
          } else {
            actions.push($api.update({
              model: 'order_file',
              data: orderFile,
              except: ['mime']
            }));
          }
        });

        return $q.all(actions);
      }

      function customerOrders(item) {
        try {
          MainPreloader.show();

          var dialogScope = $scope.$new(true);

          dialogScope.values = { item: null };

          dialogScope.tableConfig = {
            model: 'order',
            getDataParams: {
              pagination_limit: 10,
              order: {
                created_at: 'desc'
              },
              where: [
                ['customer_id', '=', item.customer_id]
              ],
              with: ['order_files'],
              getAttrs: ['arranged_order_tasks']
            }
          };

          dialogScope.description = function (item2) {
            var dialogScope2 = $scope.$new(true);

            dialogScope2.item = item2;

            ngDialog.openConfirm({
              template: 'app/views/dialogs/order-description.html',
              className: 'ngdialog-theme-default',
              scope: dialogScope2
            });
          };

          dialogScope.tableConfig.getData = function () {
            try {
              return $rootScope.helpers.defaultGetData(dialogScope.tableConfig);
            } catch (error) {
              Raven.captureException(error);
            }

            return $rootScope.helpers.emptyPromise();
          };

          dialogScope.search = function (value) {
            dialogScope.tableConfig.getDataParams.page = 1;

            dialogScope.tableConfig.getDataParams.search = value;

            if (dialogScope.request && dialogScope.request.cancel) {
              dialogScope.request.cancel();
            }

            dialogScope.request = dialogScope.tableConfig.getData();
          };

          dialogScope.tableConfig.getData().then(function () {
            ngDialog.openConfirm({
              template: 'app/views/dialogs/customer-orders.html',
              className: 'ngdialog-theme-default ngdialog-wide',
              scope: dialogScope
            }).then(function () {
              dialogScope.$applyAsync(function () {
                if (dialogScope.values.item !== null) {
                  var selectedItem = dialogScope.values.item;

                  item.name = selectedItem.name;
                  item.description = selectedItem.description;
                  item.emails = selectedItem.emails;
                  vm.tableConfig.lists.order_tasks_links = {};
                  item.order_tasks = [];
                  item.order_files = [];

                  selectedItem.arranged_order_tasks.forEach(function (orderTask, index) {
                    item.order_tasks.push({
                      order_task_type_id: orderTask.order_task_type_id,
                      deadline: item.deadline
                    });

                    if (orderTask.referer_id !== null) {
                      vm.tableConfig.lists.order_tasks_links[index] = true;
                    }
                  });

                  selectedItem.order_files.forEach(function (orderFile) {
                    item.order_files.push({
                      type: orderFile.type,
                      name: orderFile.name,
                      url: orderFile.url
                    });
                  });
                }
              });
            });
          });
        } catch (error) {
          MainPreloader.hide();

          Raven.captureException(error);
        }
      }

      function getDeadlineText(item) {
        return moment(item.deadline).fromNow();
      }

      function getDeadlineClass(item) {
        var nowMoment = moment();
        var deadlineMoment = moment(item.deadline);

        if (item.status === 'finished') {
          return 'hidden';
        }

        if (nowMoment.isAfter(deadlineMoment)) {
          return 'text-danger';
        }

        if (nowMoment.add(1, 'day').isAfter(deadlineMoment)) {
          return 'text-warning';
        }

        return 'text-muted';
      }

      vm.tableConfig = {
        model: 'order',
        getDataParams: {
          order: {
            created_at: 'desc'
          },
          with: [
            'order_files',
            {
              user: ['id', 'name']
            },
            {
              customer: ['id', 'name']
            }
          ],
          where: [
            ['archived', '=', false]
          ],
          getAttrs: ['arranged_order_tasks', 'current_order_task', 'next_order_task']
        },
        filters: filters(),
        resources: ['customer', 'order_task_type'],
        resourceUpdateConditions: {
          order_task_type: {
            params: function () {
              return {
                selectOptions: ['id', 'slug', 'name']
              };
            }
          },
          customer: {
            params: function () {
              return {
                selectOptions: ['id', 'name', 'emails']
              };
            }
          }
        },
        lists: {
          status_types: $rootScope.appConfig.types.status_types,
          order_tasks_links: {},
          order_file_types: $rootScope.appConfig.types.order_file_types
        },
        helpers: {
          addFile: addFile,
          addOrderTask: addOrderTask,
          allowDropFiles: allowDropFiles,
          customerOrders: customerOrders,
          dropFiles: dropFiles,
          getDeadlineClass: getDeadlineClass,
          getDeadlineText: getDeadlineText,
          isEmailPresent: isEmailPresent,
          leaveDropFiles: leaveDropFiles,
          removeFile: removeFile,
          removeFiles: removeFiles,
          removeOrderTask: removeOrderTask,
          removeSelectedFiles: removeSelectedFiles,
          addAllFiles: addAllFiles,
          setCustomer: setCustomer,
          toggleEmail: toggleEmail,
          toggleEmails: toggleEmails
        },
        variables: {
          userEmail: $rootScope.appConfig.user.email,
          customersConfigTable: {
            model: 'customer',
            getDataParams: {},
            getData: $rootScope.helpers.emptyPromise,
            resources: ['user'],
            add: {
              item: {
                emails: []
              },
              template: 'app/views/dialogs/item-customer.html',
              wide: true,
              success: function (response, item) {
                return new Promise(function (resolve) {
                  item.id = response.data.id;
                  orderDialogScope.config.variables.customer = item;
                  orderDialogScope.resources.customer.push(item);
                  orderDialogScope.item.customer_id = item.id;
                  orderDialogScope.item.emails = item.emails;

                  resolve();
                });
              }
            },
            edit: {
              template: 'app/views/dialogs/item-customer.html',
              wide: true,
              before: function (item, scope) {
                return new Promise(function (resolve, reject) {
                  try {
                    MainPreloader.show();

                    $api.getOne({
                      model: 'customer',
                      data: {},
                      id: item.id
                    }).then(function (response) {
                      scope.item = response.data;

                      MainPreloader.hide();

                      resolve();
                    });
                  } catch (error) {
                    MainPreloader.hide();

                    reject(error);
                  }
                });
              },
              success: function (response, item) {
                orderDialogScope.config.variables.customer = item;
                orderDialogScope.item.customer_id = item.id;
                orderDialogScope.item.emails = item.emails;

                return $rootScope.helpers.emptyPromise();
              }
            }
          },
          customer: null
        },
        fields: [{
          title: 'Date',
          key: 'created_at',
          order: true
        }, {
          title: 'ID',
          key: 'uid',
          order: true
        }, {
          title: 'Title',
          key: 'name',
          order: true
        }, {
          title: 'Creator',
          key: 'user_id',
          order: true
        }, {
          title: 'Created',
          key: 'created_at',
          order: true
        }, {
          title: 'Deadline',
          key: 'deadline',
          order: true
        }, {
          title: 'Status',
          key: 'status',
          sort: true
        }],
        add: {
          template: 'app/views/dialogs/item-order.html',
          wide: true,
          item: {
            order_tasks: [],
            order_files: [],
            emails: [],
            include_user_email: true
          },
          before: function (item, scope) {
            window.addEventListener('paste', pasteFile(item));

            return new Promise(function (resolve, reject) {
              try {
                scope.config.variables.customer = undefined;
                orderDialogScope = scope;

                MainPreloader.show();

                $api.get({
                  path: '/api/next_order_id'
                }).then(function (response) {
                  item.uid = response.data;

                  MainPreloader.hide();

                  resolve();
                });
              } catch (error) {
                MainPreloader.hide();

                Raven.captureException(error);

                reject(error);
              }
            });
          },
          success: function (response) {
            // Setup referers for order tasks
            return new Promise(function (resolve, reject) {
              try {
                MainPreloader.show();

                $api.getOne({
                  model: 'order',
                  data: {
                    with: ['order_tasks']
                  },
                  id: response.data.id
                }).then(function (orderResponse) {
                  var orderTasks = orderResponse.data.order_tasks;

                  for (var i = 1; i < orderTasks.length; i++) {
                    if (vm.tableConfig.lists.order_tasks_links[i]) {
                      orderTasks[i].referer_id = orderTasks[i - 1].id;
                    }
                  }

                  $api.update({
                    model: 'order',
                    data: orderResponse.data
                  }).then(function () {
                    vm.tableConfig.lists.order_tasks_links = [];

                    MainPreloader.hide();

                    resolve();
                  });
                });
              } catch (error) {
                MainPreloader.hide();

                reject(error);
              }
            });
          },
          onClose: function (item) {
            window.removeEventListener('paste', pasteFile(item));
          }
        },
        edit: {
          template: 'app/views/dialogs/item-order.html',
          except: [
            'customer',
            'current_order_task',
            'next_order_task',
            'status',
            'arranged_order_tasks',
            'cname',
            'user',
            'order_files'
          ],
          wide: true,
          before: function (item, scope) {
            window.addEventListener('paste', pasteFile(item));

            return new Promise(function (resolve, reject) {
              try {
                scope.config.variables.customer = undefined;
                orderDialogScope = scope;

                MainPreloader.show();

                $api.getOne({
                  model: 'customer',
                  data: {},
                  id: item.customer_id
                }).then(function (response) {
                  scope.config.variables.customer = response.data;

                  MainPreloader.hide();

                  resolve();
                });
              } catch (error) {
                MainPreloader.hide();

                reject(error);
              }
            });
          },
          beforeSubmit: function (item) {
            return new Promise(function (resolve, reject) {
              try {
                processFiles(item.id, item.order_files).then(function () {
                  resolve(item);
                });
              } catch (error) {
                Raven.captureException(error);

                reject(error);
              }
            });
          },
          onClose: function (item) {
            window.removeEventListener('paste', pasteFile(item));
          }
        },
        delete: {},
        customButtons: [{
          permission: $rootScope.helpers.hasPermissionTo('order_file view') || $rootScope.helpers.hasPermissionTo('order_file edit'),
          title: 'Order files',
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);
              dialogScope.types = $rootScope.appConfig.types.order_file_types;
              dialogScope.addFile = addFile;
              dialogScope.removeFile = removeFile;
              dialogScope.removeFiles = removeFiles;
              dialogScope.dropFiles = dropFiles;
              dialogScope.allowDropFiles = allowDropFiles;
              dialogScope.leaveDropFiles = leaveDropFiles;
              dialogScope.hasPermissionTo = $rootScope.helpers.hasPermissionTo;

              window.addEventListener('paste', pasteFile(dialogScope.item));

              ngDialog.openConfirm({
                template: 'app/views/dialogs/order-files.html',
                className: 'ngdialog-theme-default ngdialog-wide',
                scope: dialogScope,
                closeByDocument: false
              }).then(function () {
                MainPreloader.show();

                window.removeEventListener('paste', pasteFile(dialogScope.item));

                processFiles(dialogScope.item.id, dialogScope.item.order_files).then(function () {
                  if (dialogScope.item.notify_files_update) {
                    $api.update({
                      model: 'order',
                      data: {
                        id: item.id,
                        notify_files_update: true
                      }
                    }).then(MainPreloader.hide, MainPreloader.hide);
                  } else {
                    $api.triggerOne({
                      model: 'order',
                      id: item.id
                    }).then(MainPreloader.hide, MainPreloader.hide);
                  }
                }, function () {
                  MainPreloader.hide();

                  window.removeEventListener('paste', pasteFile);
                });
              });
            } catch (error) {
              Raven.captureException(error);
            }
          },
          icon: 'icon-paper-clip',
          class: 'btn-default',
          text: function (item) {
            return item.order_files.length;
          }
        }, {
          title: 'Order invoice',
          icon: 'icon-calculator',
          class: function (item) {
            return item.invoice_date ? 'btn-primary' : 'btn-default';
          },
          permission: $rootScope.helpers.hasPermissionTo('order edit'),
          action: function (item) {
            try {
              var dialogScope = $scope.$new(true);

              dialogScope.item = angular.copy(item);

              ngDialog.openConfirm({
                template: 'app/views/dialogs/order-invoice.html',
                className: 'ngdialog-theme-default',
                scope: dialogScope,
                closeByDocument: false
              }).then(function () {
                MainPreloader.show();

                $api.update({
                  model: 'order',
                  data: dialogScope.item,
                  only: ['invoice_uid', 'invoice_date']
                }).then(MainPreloader.hide, MainPreloader.hide);
              });
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          title: 'Order label',
          icon: 'icon-tag',
          class: 'btn-default',
          permission: $rootScope.helpers.hasPermissionTo('order view'),
          action: function (item) {
            try {
              var printers = $rootScope.appConfig.printers || [];

              if (printers.length > 0) {
                MainPreloader.show();

                var printerId = $window.localStorage.getItem('printerId') || printers[0].id;

                $api.post({
                  path: '/api/print_order_label',
                  data: {
                    order_id: item.id,
                    printer_id: printerId
                  },
                  notifications: {
                    success: 'Printed successfully',
                    error: 'Unable to print'
                  }
                }).then(MainPreloader.hide, MainPreloader.hide);
              }
            } catch (error) {
              MainPreloader.hide();

              Raven.captureException(error);
            }
          }
        }, {
          title: 'Order page',
          icon: 'icon-doc',
          class: 'btn-default',
          permission: $rootScope.helpers.hasPermissionTo('order view'),
          action: function (item) {
            try {
              $window.open($rootScope.config.server_url + '/documents/order-page/' + item.id, '_blank');
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }, {
          title: 'Order tasks',
          icon: 'icon-check',
          class: 'btn-info',
          permission: $rootScope.helpers.hasPermissionTo('order_task view'),
          action: function (item) {
            try {
              $state.go('app.page-order-tasks', {
                filters: [{
                  name: $translate.instant('Order') + ': ' + item.cname,
                  attr: 'where',
                  value: [
                    ['order_id', '=', item.id]
                  ]
                }]
              });
            } catch (error) {
              Raven.captureException(error);
            }
          }
        }]
      };

      var orderTasksController = $controller('OrderTasksController', {
        $scope: $scope.$new()
      });

      vm.orderTasksTableConfig = orderTasksController.tableConfig;
      vm.orderTasksTableConfig.add.success = updateData;
      vm.orderTasksTableConfig.edit.success = updateData;

      vm.tableConfig.getData = function () {
        try {
          return $rootScope.helpers.defaultGetData(vm.tableConfig);
        } catch (error) {
          Raven.captureException(error);
        }

        return $rootScope.helpers.emptyPromise();
      };

      vm.tableConfig.getData();

      $rootScope.helpers.initActiveTableConfig(vm.tableConfig);
    }
  }
})();
